export default __webpack_public_path__ + "static/4-0da9632addde0b4306afda0ffebc16eb.png";